const buildUrl = container => {
  const {
    itemBuReference,
    itemOfferIdentifier,
    storeId,
    thirdParty,
    webExclusive,
    currencyCode,
    fulfillerName
  } = container.dataset;
  const params = new URLSearchParams({
    itemBuReference,
    itemOfferIdentifier,
    storeId,
    thirdParty,
    webExclusive,
    currencyCode,
    fulfillerName
  });
  return `/services/accurate-lead-time?${params.toString()}`;
};
const replaceDrawers = drawers => {
  if (!drawers) {
    return;
  }
  Array.from(drawers.children).forEach(newDrawer => {
    const layerClass = Array.from(newDrawer.classList).find(c => c.startsWith('js-layer-'));
    const oldDrawer = layerClass && document.querySelector(`.${layerClass}`);
    if (oldDrawer) {
      oldDrawer.replaceWith(newDrawer);
    }
  });
};
const replaceBlocks = (containers, html) => {
  const template = document.createElement('template');
  template.innerHTML = html;
  replaceDrawers(template.content.querySelector('[data-accurate-lead-time-drawers]'));
  template.content.querySelectorAll('[data-accurate-lead-time-type]').forEach(block => {
    const old = containers.find(c => c.dataset.type === block.dataset.accurateLeadTimeType);
    if (old) {
      old.replaceWith(block);
    }
  });
};
const reveal = container => {
  container.classList.remove('mu-hidden');
  container.removeAttribute('aria-busy');
};
export const initAccurateLeadTime = async component => {
  const containers = Array.from(component.querySelectorAll('.js-accurate-lead-time'));
  const loaders = Array.from(component.querySelectorAll('.js-accurate-lead-time-loader'));
  if (!containers.length) {
    return;
  }
  try {
    const response = await fetch(buildUrl(containers[0]));
    if (response.status === 200) {
      replaceBlocks(containers, await response.text());
    }
  } catch (e) {
    console.warn('[PDP] Accurate lead time unavailable', e);
  } finally {
    loaders.forEach(l => l.remove());
    containers.filter(c => c.isConnected).forEach(reveal);
  }
};